import React from 'react';
import { HelpCircle } from 'lucide-react';
import { motion } from 'motion/react';

interface HelpButtonProps {
  onClick: () => void;
}

export function HelpButton({ onClick }: HelpButtonProps) {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      className="fixed top-4 left-4 z-40 w-10 h-10 rounded-full bg-white border-2 border-zinc-200 shadow-lg flex items-center justify-center hover:border-green-500 transition-colors"
      title="Show Help Guide"
    >
      <HelpCircle className="w-5 h-5 text-zinc-600" />
    </motion.button>
  );
}